(() => {
  if (window.lctProductTabsReady) return;
  window.lctProductTabsReady = true;
  const previewContext = new URL(window.location.href);
  customElements.whenDefined('product-info').then(() => {
    const proto = customElements.get('product-info').prototype;
    if (proto.lctPreviewAware) return;
    proto.lctPreviewAware = true;
    const build = proto.buildRequestUrlWithParams;
    const update = proto.updateURL;
    proto.buildRequestUrlWithParams = function (...args) {
      const result = build.apply(this, args);
      if (!this.classList.contains('lct-pdp')) return result;
      const target = new URL(result, window.location.origin);
      const view = previewContext.searchParams.get('view');
      if (view) target.searchParams.set('view', view);
      if (previewContext.pathname === '/products_preview' && args[0] === this.dataset.url) {
        target.pathname = previewContext.pathname;
        target.searchParams.set('preview_key', previewContext.searchParams.get('preview_key'));
      }
      return target.toString();
    };
    proto.updateURL = function (url, variantId) {
      update.call(this, url, variantId);
      if (!this.classList.contains('lct-pdp') || this.dataset.updateUrl === 'false') return;
      const target = new URL(window.location.href);
      if (previewContext.searchParams.has('view')) target.searchParams.set('view', previewContext.searchParams.get('view'));
      if (previewContext.pathname === '/products_preview' && url === this.dataset.url) {
        target.pathname = previewContext.pathname;
        target.searchParams.set('preview_key', previewContext.searchParams.get('preview_key'));
      }
      history.replaceState({}, '', target);
    };
  });
  const activate = tab => {
    const root = tab.closest('[data-lct-tabs]');
    root.querySelectorAll('[role="tab"]').forEach(other => {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      other.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  };
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-lct-tabs] [role="tab"]');
    if (tab) activate(tab);
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-lct-tabs] [role="tab"]');
    if (!tab) return;
    const tabs = [...tab.closest('[data-lct-tabs]').querySelectorAll('[role="tab"]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else return;
    event.preventDefault(); activate(tabs[index]); tabs[index].focus();
  });
})();
